<template>
  <slot></slot>

  <modal :id="modalId">

    <template v-slot:header>
      <h4 class="modal-title">Transfer Adjusters</h4>
    </template>

    <div v-if="(checkedIds().length > 0) && (smartlists.length > 0)">

      <!-- Smartlist selector -->
      <div class="form-group row">
        <label for="id" class="col-form-label col-sm-2">Smartlist:</label>
        <div class="col-sm-10">
          <select name="id" form="transfer_form" v-model="id" class="form-control form-control-sm">
            <option v-for="list in smartlists" :value="list.id">{{ list.name }}</option>
          </select>
        </div>
      </div>

      <!-- Keep selected adjusters in original list -->
      <div class="form-group row">
        <div class="col-sm-10 offset-sm-2">
          <label class="checkbox-inline">
            <input name="keep" form="transfer_form" type="checkbox" v-model="keep"> Keep selected adjusters in original Smartlist.
          </label>
        </div>
      </div>

      <div v-if="id" class="text-center alert mb-0" :class="{'alert-danger': !keep, 'alert-warning': keep}">
        You’re about to transfer <strong>{{ checkedIds().length }}</strong> adjusters to "{{ smartlists.find(s => s.id === id).name }}" Smartlist.
        <template v-if="!keep">The selected adjusters will be removed from the original Smartlist. This action cannot be undone.</template>
        Are you sure you want to proceed?
      </div>
    </div>

    <div v-else class="alert alert-warning text-center mb-0">
      <template v-if="smartlists.length === 0">
        No active Smartlists available for transfer.
      </template>
      <template v-else>
        No adjusters selected.
      </template>
    </div>

    <template v-slot:footer>
      <button type="button" class="btn btn-white" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>

      <form method="POST" :action="action" id="transfer_form">
        <input type="hidden" name="_token" :value="$csrf_token">
        <input type="hidden" name="adjuster_ids" :value="checkedIds()">
        <button v-if="(checkedIds().length > 0) && (smartlists.length > 0)" type="submit" class="btn btn-primary" :disabled="!id"><i class="fa fa-fw fa-share-square-o"></i> Confirm Transfer</button>
      </form>
    </template>

  </modal>
</template>

<script>
import HasModal from "../mixins/HasModal";
import { mapState } from 'pinia'
import { useCheckboxListStore } from "../../stores/checkboxList"

export default {
  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      type: String,
      default: 'smartlistTransferAdjusterModal'
    },

    // Form action value.
    action: {
      type: String,
      required: true
    },

    smartlists: {type: Array, default: function () { return [] }},
  },

  data () {
    return {
      id: null,
      keep: true,
    }
  },

  /**
   * Computed values
   */
  computed: {
    ...mapState(useCheckboxListStore, ['checkedIds']),
  },
}
</script>
